import { render, staticRenderFns } from "./AttentionZt.vue?vue&type=template&id=22b965e3&scoped=true"
import script from "./AttentionZt.vue?vue&type=script&lang=js"
export * from "./AttentionZt.vue?vue&type=script&lang=js"
import style0 from "./AttentionZt.vue?vue&type=style&index=0&id=22b965e3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b965e3",
  null
  
)

export default component.exports